import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';
import { fromJS } from 'immutable';

import { reportError } from '../../utils/error-handling-service';
import { authService } from '../../utils/auth-service';
import { fetchUser, updateUser } from '../../utils/jsonapi-functions/users';
import { getOnboardingState } from '../../selectors/user-onboarding-state-selectors';
import {
  LOAD_ONBOARDING_STATE,
  LOAD_ONBOARDING_STATE_SUCCESS,
  LOAD_ONBOARDING_STATE_ERROR,
  UPDATE_ONBOARDING_STATE,
  UPDATE_ONBOARDING_STATE_ERROR,
} from './constants';

export function* loadUserOnboardingState(action) {

  try {
    const userId = authService.uid();

    const userData = yield call(fetchUser, userId);
    const userDataJSON = userData.toJSONTree();

    const viewedOnboarding = fromJS(userDataJSON.viewedOnboardingState);
    yield put({ type: LOAD_ONBOARDING_STATE_SUCCESS, viewedOnboarding });

  } catch (error) {
    reportError('LOAD_ONBOARDING_STATE_ERROR', error.message);
    yield put({ type: LOAD_ONBOARDING_STATE_ERROR, error: error.message });
  }
}

export function* updateUserOnboardingState(action) {

  try {
    const { page, onboardingState, callback } = action.data;

    const currentOnboardingState = yield select(getOnboardingState);

    const onboardingStateJSON = currentOnboardingState.toJS();

    if (onboardingStateJSON[page][onboardingState] === false) {
      onboardingStateJSON[page][onboardingState] = true;

      const userId = authService.uid();

      const updatedUser = yield call(updateUser, userId, { viewedOnboardingState: onboardingStateJSON });
      const viewedOnboarding = fromJS(updatedUser.toJSONTree());

      yield put({ type: LOAD_ONBOARDING_STATE_SUCCESS, viewedOnboarding });

      if (callback) callback();
    }
  } catch (error) {
    reportError('UPDATE_ONBOARDING_STATE_ERROR', error.message);
    yield put({ type: UPDATE_ONBOARDING_STATE_ERROR, error: error.message });
  }
}

export function* watchLoadOnboardingStateSagas() {
  yield takeLatest(LOAD_ONBOARDING_STATE, loadUserOnboardingState);
}

export function* watchUpdateOnboardingStateSagas() {
  yield takeLatest(UPDATE_ONBOARDING_STATE, updateUserOnboardingState);
}

export default function* userOboardingStateSagas() {
  yield [
    fork(watchLoadOnboardingStateSagas),
    fork(watchUpdateOnboardingStateSagas),
  ];
}



/** WEBPACK FOOTER **
 ** ./src/containers/user-onboarding-state/sagas.js
 **/